import {
  INIT,
  INIT_ALL_REQUESTS,
  SET_PAYLOAD,
  SET_RESPONSE,
  FETCHING,
  FETCHING_SUCCESS,
  FETCHING_FAIL,
  ABORT_FETCHING,
  SWITCH_REQUEST,
} from './types';

export const createInit = type => index => ({
  type: `${type}${INIT}`,
  index,
});

export const createInitAllRequests = type => count => ({
  type: `${type}${INIT_ALL_REQUESTS}`,
  count,
});

export const createSwitchRequest = type => (index, target) => ({
  type: `${type}${SWITCH_REQUEST}`,
  index,
  target,
});

export const createSetPayload = type => payload => ({
  type: `${type}${SET_PAYLOAD}`,
  payload,
});

export const createSetResponse = type => (index, response) => ({
  type: `${type}${SET_RESPONSE}`,
  index,
  response,
});

export const createFetching = type => index => ({
  type: `${type}${FETCHING}`,
  index,
});

export const createFetchingSuccess = type => (index, response) => ({
  type: `${type}${FETCHING_SUCCESS}`,
  index,
  response,
});

export const createFetchingFail = type => (index, errorCode, errorMsg) => ({
  type: `${type}${FETCHING_FAIL}`,
  index,
  errorCode,
  errorMsg,
});

export const createAbortFetching = type => index => ({
  type: `${type}${ABORT_FETCHING}`,
  index,
});

const createAllActions = type => ({
  initAllRequests: createInitAllRequests(type),
  switchRequest: createSwitchRequest(type),
  init: createInit(type),
  setPayload: createSetPayload(type),
  setResponse: createSetResponse(type),
  fetching: createFetching(type),
  fetchingSuccess: createFetchingSuccess(type),
  fetchingFail: createFetchingFail(type),
  abortFetching: createAbortFetching(type),
});

export default createAllActions;
